import React, { useMemo } from 'react';

import type { UserContextProviderProps } from './types';
import { useSiteChromeStaticContext } from 'client-site-chrome-ui/context/SiteChromeStaticContext/useSiteChromeStaticContext';
import { UserContext } from 'client-site-chrome-ui/context/UserContext/UserContext';
import { useAuthentication } from 'client-site-chrome-ui/hooks/useAuthentication';
import { useBasket } from 'client-site-chrome-ui/hooks/useBasket';
import { useFavourites } from 'client-site-chrome-ui/hooks/useFavourites';
import { useMembership } from 'client-site-chrome-ui/hooks/useMembership';

export const UserContextProvider = ({ children, ...props }: UserContextProviderProps) => {
  const { cookies, env, mergeBasket } = useSiteChromeStaticContext();
  const userAuthenticated = useAuthentication();
  const { membershipIsActive } = useMembership();
  const basketItemsCount = useBasket({ cookies, env, mergeBasket });
  const hasFavouriteProducts = useFavourites(env);

  const userContextValue = useMemo(
    () => ({
      userAuthenticated,
      membershipIsActive,
      basketItemsCount,
      hasFavouriteProducts,
    }),
    [userAuthenticated, membershipIsActive, basketItemsCount, hasFavouriteProducts],
  );

  return (
    <UserContext.Provider value={userContextValue} {...props}>
      {children}
    </UserContext.Provider>
  );
};
